import { useState, useEffect } from "react";
import { fetchBestInCategoryData, type TimeRange, type BestInCategoryData } from "@/app/services/analytics/best-in-category-api";
import { useAnalyticsRefreshTrigger } from "./useAnalyticsRefreshTrigger";

export function useBestInCategoryData(
  timeRange: TimeRange,
  antennaData?: any,
  selectedModels?: string[],
) {
  const [data, setData]           = useState<BestInCategoryData | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError]         = useState<Error | null>(null);
  const refreshKey                = useAnalyticsRefreshTrigger();

  useEffect(() => {
    let cancelled = false;
    setIsLoading(true);
    setError(null);
    fetchBestInCategoryData(timeRange, antennaData, selectedModels)
      .then(r  => { if (!cancelled) { setData(r); setIsLoading(false); } })
      .catch(e => { if (!cancelled) { setError(e instanceof Error ? e : new Error(String(e))); setIsLoading(false); } });
    return () => { cancelled = true; };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [timeRange, refreshKey]);

  return { data, isLoading, error };
}